export const timezones = {
    pacific: "Pacífico",
    mountain: "Montaña",
    central: "Central",
    eastern: "Oriental"
}